import styled from 'styled-components';
import { color, font, query, space } from '@design/templateFns';

export const PressReleaseWrapper = styled.article<{
  $backgroundColor?: boolean;
}>`
  display: flex;
  flex-direction: column;
  position: relative;
  width: 100%;
  height: 100%;
  padding: ${space('x6')} ${space('x6')} ${space('x5')} ${space('x6')};
  background-color: ${({ $backgroundColor }) =>
    $backgroundColor ? color('bg') : color('secondaryBg')};
  border-color: ${color('cta')};
  border-width: 0 0 0 2px;
  border-style: solid;
  position: relative;
  box-sizing: border-box;
  transition: color 0.2s ease-in-out;
  margin-bottom: ${space('x6')};

  @media screen and (${query.below('desktop')}) {
    margin-bottom: 0;
  }

  @media screen and (${query.atLeast('tablet')}) {
    min-height: 350px;
  }

  a {
    margin-top: auto;
    color: ${color('fg')};

    @media screen and (${query.atLeast('tablet')}) {
      opacity: 0;
      transition: opacity 0.2s ease-in-out;
    }

    &::after {
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      z-index: 1;
      content: '';
    }
    &:not(:disabled):hover {
      // a little more specificity to default styling
      color: ${color('fg')};
    }
  }
  &:hover {
    color: ${color('fg')};
    @media screen and (${query.atLeast('tablet')}) {
      a {
        opacity: 1;
      }
    }
  }
`;

export const BodyTextWrapper = styled.div`
  ${font('body-md-light')};

  @media screen and (${query.below('desktop')}) {
    ${font('body-sm-light')};
    margin-bottom: ${space('x5')};
  }
`;

export const TitleWrapper = styled.div`
  h3 {
    ${font('subhead-lg')};
    margin-top: 0;
    padding-bottom: ${space('xl')};

    @media screen and (${query.below('desktop')}) {
      ${font('subhead-md')};
    }
  }
`;

export const DateWrapper = styled.div`
  ${font('eyebrow-sm')};
  color: ${color('gray5')};
  text-transform: uppercase;
  margin-top: auto;
`;

export const PressReleaseFooter = styled.footer`
  flex: 1 0 0%;
  padding-top: ${space('md')};
  display: flex;
  justify-content: space-between;
  align-items: baseline;
`;

// For use in Story
export const StoryWrapper = styled.div`
  display: flex;
`;
